export default __webpack_public_path__ + "static/media/India–EU-FTA.e86e3e44.png";